<template>
  <div class="popup-overlay">
    <div class="popup-content">
      <div class="form-header">
        <div class="photo-box">
          <img
            :src="editedStudent.photo !== null && editedStudent.photo !== ''
                    ? `https://manna.dongan1718.com/upload/photo/${editedStudent.photo}` 
                    : editedStudent.photo2 !== null && editedStudent.photo2 !== ''
                    ? `https://manna.dongan1718.com/upload/photo/${editedStudent.photo2}` 
                    : require('@/assets/img/noimage.png')"          
            alt="photo"
          />

        </div>
        <div class="info-box">
          <div class="form-row">
            <div class="form-group left-label">
              <label>이름:</label>
              <input
                type="text"
                readonly
                v-model="editedStudent.name"
                class="form-control short-input30"
              />
            </div>
            <div class="form-group left-label">
              <label>학년/반:</label>
              <input
                type="text"
                readonly
                v-model="editedStudent.gradename"
                class="form-control short-input30"
              />
            </div>
          </div>
          <div class="form-group left-label">
            <label>생년월일:</label>
            <input
              type="text"
              readonly
              v-model="editedStudent.birthday"
              class="form-control short-input30"
            />
          </div>
        </div>
      </div>
      <form @submit.prevent="saveChanges">
        <div class="form-row">
          <div class="form-group half-width left-label">
            <label style="width:130px">휴대폰 번호:</label>
            <input
              type="text"
              readonly
              v-model="editedStudent.phone"
              class="form-control"
            />
          </div>
          <div class="form-group half-width left-label">
            <label style="width:130px">학부모 연락처:</label>
            <input
              type="text"
              readonly
              v-model="editedStudent.parentphone"
              class="form-control"
            />
          </div>
        </div>
        <div class="form-group left-label">
          <label style="width:90px">학교:</label>
          <input type="text" v-model="editedStudent.school" readonly class="form-control short-input50" />
        </div>
        <div class="form-group left-label">
          <label>주소:</label>
          <input type="text" v-model="editedStudent.address" readonly class="form-control" />
        </div>
        <div class="form-group left-label">
          <label>비고:</label>
          <textarea v-model="editedStudent.rmk" readonly class="form-control"></textarea>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <span style="color:gray">* 정보수정은 학생(아동)기록부에서 가능합니다. </span>
          <button type="button" class="btn btn-secondary me-2" @click="close">
            닫기
          </button>
          <!-- <button type="submit" class="btn btn-primary">저장</button> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editedStudent: { ...this.student },
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    saveChanges() {
      this.$emit("save", this.editedStudent);
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 10%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 60%;
  max-width: 800px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  margin: auto;
  overflow-y: auto;
}

.form-header {
  display: flex;
  flex-wrap: wrap; /* 반응형 처리 */
  margin-bottom: 20px;
}

.photo-box {
  width: 300px;
  /* height: 120px; */
  margin-right: 20px;
}

.photo-box img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10%; /* 둥근 프로필 사진 */
}

.info-box {
  flex: 1;
  min-width: 200px; /* 최소 너비 설정 */
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap; /* 반응형 줄바꿈 처리 */
}

.left-label label {
  width: 100px;
  margin-right: 10px;
  text-align: right;
}

input,
textarea {
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

input:focus,
textarea:focus {
  outline: none;
  border: 2px solid #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.5);
}

textarea {
  resize: vertical;
}

.short-input30 {
  width: 30%;
}

.short-input50 {
  width: 50%;
}

.half-width {
  width: 48%; /* 두 입력 칸을 한 줄에 배치 (간격 고려) */
}

.d-flex {
  display: flex;
}

.justify-content-end {
  justify-content: flex-end;
}

.mt-3 {
  margin-top: 15px;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .popup-content {
    width: 90%; /* 모바일에서 팝업 너비 조정 */
  }

  .form-header {
    flex-direction: column; /* 모바일에서는 세로 배치 */
    align-items: center;
  }

  .photo-box {
    margin-right: 0;
    margin-bottom: 15px; /* 사진과 정보 간격 추가 */
  }

  .form-row {
    flex-direction: column;
  }

  .half-width {
    width: 100%; /* 모바일에서는 한 줄에 한 입력 칸 */
  }
}
</style>
